const getUniList = (unifiedListUnfiltered) =>
  unifiedListUnfiltered
    ? unifiedListUnfiltered.map((item) => ({
        label: item?.label,
        value: item?.value,
        data_type: item?.data_type,
      }))
    : [];

const getUpdatedDmnList = (dmnOutputList) =>
  dmnOutputList.map((element) => ({ ...element, data_type: 'number' }));

const getOutputVarsForDmnList = (outputFields: any[] = []) =>
  outputFields.map((item) => {
    let newtype: string;
    let dataType;
    if (item?.type === 'double') {
      newtype = 'number';
      dataType = 'number';
    } else if (item?.type === 'string') {
      newtype = 'text';
      dataType = 'text';
    } else {
      newtype = item?.type;
      dataType = item?.type;
    }
    return {
      label: item?.name,
      data_type: newtype,
      dataType,
      name: item?.name,
      value: item?.name,
    };
  });

const dedupeBy = (list, keyFn) => {
  const seen = new Set();
  return list.filter((item) => {
    const key = keyFn(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// Builds state.concatList + state.configFields from unified list + DMN output columns
export function buildConfigFields({
  unifiedListUnfiltered,
  ruleType,
  dmnOutputList,
  dmnDataOutputFields,
}) {
  const uniList = getUniList(unifiedListUnfiltered);
  const updatedDmnList =
    dmnOutputList && dmnOutputList.length > 0
      ? getUpdatedDmnList(dmnOutputList)
      : [];
  const outVarsForDmnList =
    dmnDataOutputFields && dmnDataOutputFields.length > 0
      ? getOutputVarsForDmnList(dmnDataOutputFields)
      : [];

  let list: any[] = [];
  if (uniList && ruleType) {
    const hasUpdatedDmnList = updatedDmnList.length > 0;
    const hasDmnOutputFields = outVarsForDmnList.length > 0;
    if (hasUpdatedDmnList && hasDmnOutputFields) {
      list = [...uniList, ...updatedDmnList, ...outVarsForDmnList];
    } else if (hasDmnOutputFields) {
      list = [...uniList, ...outVarsForDmnList];
    } else if (hasUpdatedDmnList) {
      list = [...uniList, ...updatedDmnList];
    } else {
      list = [...uniList];
    }
  }
  if ((!uniList || !ruleType) && updatedDmnList.length > 0) {
    list = [...updatedDmnList];
  }

  const uniqueList = dedupeBy(list, (item) => item?.value ?? item?.label);

  let configFields = [];
  if (uniqueList?.length > 0) {
    const updatedConfigData = uniqueList.map((item) => {
      let dataType;
      if (item?.data_type === 'string') {
        dataType = 'text';
      } else if (item?.data_type === 'double') {
        dataType = 'number';
      } else {
        dataType = item?.data_type;
      }
      return { ...item, columnType: 'normal', name: item?.label, dataType };
    });
    configFields = dedupeBy(
      updatedConfigData,
      (item) => item?.name ?? item?.label
    );
  }

  return { concatList: uniqueList, configFields };
}

// Builds the Output Formula dropdown fields for group-adjustment rules
export function buildGroupConfigFields({ dmnOutputList, dmnDataOutputFields }) {
  return [
    ...(dmnOutputList?.length > 0
      ? dmnOutputList.map((element) => ({
          ...element,
          data_type: 'number',
          columnType: 'normal',
          name: element?.label,
          dataType:
            element?.data_type === 'string' ? 'text' : element?.data_type,
        }))
      : []),
    ...(dmnDataOutputFields?.length
      ? dmnDataOutputFields.map((item) => {
          let newType;
          let dataType;
          if (item?.type === 'double') {
            newType = 'number';
            dataType = 'number';
          } else if (item?.type === 'string') {
            newType = 'text';
            dataType = 'text';
          } else {
            newType = item?.type;
            dataType = item?.type;
          }
          return {
            label: item?.name,
            value: item?.name,
            data_type: newType,
            columnType: 'normal',
            name: item?.name,
            dataType,
          };
        })
      : []),
    {
      label: 'Final Payout',
      value: 'Final Payout',
      data_type: 'number',
      columnType: 'normal',
      name: 'Final Payout',
      dataType: 'number',
    },
  ];
}
